function storageKey(sessionId: string): string {
  return `customer_commerce_order_id:${sessionId}`;
}

export function readPersistedCommerceOrderId(sessionId: string): string | undefined {
  try {
    const value = window.sessionStorage.getItem(storageKey(sessionId));
    if (value === null) {
      return undefined;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : undefined;
  } catch {
    return undefined;
  }
}

export function persistCommerceOrderId(sessionId: string, commerceOrderId: string): void {
  const trimmed = commerceOrderId.trim();
  if (trimmed.length === 0) {
    return;
  }
  try {
    window.sessionStorage.setItem(storageKey(sessionId), trimmed);
  } catch {
    // sessionStorage may be unavailable
  }
}

export function readCommerceOrderIdFromUnknown(data: unknown): string | undefined {
  if (data === null || typeof data !== 'object') {
    return undefined;
  }
  const value = (data as { commerceOrderId?: unknown }).commerceOrderId;
  if (typeof value !== 'string') {
    return undefined;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}
